<template>
  <div>
    <div class="d-flex">
      <slot name="header">
        <div class="d-flex flex-row pr-1 pl-0 mb-1">  
          <button-refresh size="md" style="border-radius: 4px 0px 0px 4px;" :animate="animateRefresh" :disabled="isBusy || isBusyInner" class="align-self-start" @click="autoUpdateSec=0;  $refs['page-table-no-header'].getData()"/>
          <b-input style="border-radius: 0px 4px 4px 0px; width: 60px;" :disabled="false" type="number" min="0" max="300" step="30" v-model="autoUpdateSec"></b-input>
        </div>

        <h4 v-if="title" class="card-title m-0 mr-2 mb-2 mt-1">{{title}}</h4>
      </slot>

      <div class="d-flex">
        <slot name="filter"></slot>
      </div>
      
      <div class="d-flex ml-auto">
        <slot name="header-actions">
          <button-add 
            :disabled="isBusy || isBusyInner"
            class="align-self-start mt-1 mb-2"
            v-if="showAddButton || (showAddButton === null && ($store.getters.isSuperAdmin || $store.getters.isAdmin || $store.getters.isSuperUser))" 
            @click="$emit('onAdd')" 
          />
        </slot>
        
        <h3 ><b-badge class="align-self-start ml-2" variant="success">{{totalItems}}</b-badge></h3>
      </div>
    </div>

    <page-table 
      id="base-table-card-no-header"
      ref="page-table-no-header"
      :primaryKey="primaryKey"
      :fields="fields"
      :hideFields="hideFields"      
      :updateIntervalSec="Number(autoUpdateSec)"
      :getDataFunction="getDataFunction"
      :getDataFunctionParam="getDataFunctionParam"
      :isBusy="isBusy"
      :isSortable="isSortable"
      :perPage="perPage"

      @onBusy="isBusyInner=$event"
      @dataChanged="totalItems = $event.totalItems; $emit('dataChanged', $event)"
      @animateRefresh="animateRefresh=$event"
      @onSortHeadClicked="$emit('onSortHeadClicked', $event)" 
      @rowClicked="$emit('rowClicked', $event)"      
    >

    <template v-for="(_, slot) of $slots" :slot="slot">
      <slot :name="slot"/>
    </template>

    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>

    </page-table>
  </div>  
</template>

<script>

export default {
  name: 'base-table-card-no-header',
  inheritAttrs: false,
  components: {},

  props: {
    title: {
      type: String,
      default: null
    },

    fields: {
      type: [Array, Function],
      default: () => []
    },

    hideFields: {
      type: [Array, Function],
      default: () => []
    },

    primaryKey: {
      type: String,
      default: 'id'
    },

    getDataFunction: {
      type: Function,
      default: null
    },

    getDataFunctionParam:{
      type: Object,
      default: null
    },

    showAddButton: {
      type: Boolean,
      default: null
    },

    isBusy: {
      type: Boolean,
      default: false
    },

    isSortable: {
      type: Boolean,
      default: true      
    },

    perPage: {
      type: Number,
      default: 15
    }
  },

  data: () => {
    return {
      animateRefresh: false,
      totalItems: 0,
      isBusyInner: false,
      autoUpdateSec: 0
    }
  },

  watch: {
    autoUpdateSec() {
      if (this.autoUpdateSec > 0 && this.autoUpdateSec < 30) {
        this.autoUpdateSec = 30
      }
    }
  },

  methods: {
    getData(tableBusy) {
      this.$refs['page-table-no-header'].getData(tableBusy)
    }
  }
}

</script>
